{
  "UI Elements": "UI Elements",
  "Forms & Tables": "Forms & Tables",
  "Pages": "Pages",
  "Charts & Maps": "Charts & Maps",
  "Others": "Others",
  "Typography": "Typography",
  "Cards": "Cards",
  "Basic": "Basic",
  "Advance": "Advance",
  "Widgets": "Widgets",
  "Components": "Components",
  "Alert": "Alert",
  "Close Alert": "Close Alert",
  "Avatar": "Avatar",
  "Badge": "Badge",
  "Button": "Button",
  "Calendar": "Calendar",
  "Image": "Image",
  "Pagination": "Pagination",
  "Progress Circular": "Progress Circular",
  "Progress Linear": "Progress Linear",
  "Autocomplete": "Autocomplete",
  "Tooltip": "Tooltip",
  "Slider": "Slider",
  "Date Time Picker": "Date Time Picker",
  "Select": "Select",
  "Switch": "Switch",
  "Checkbox": "Checkbox",
  "Radio": "Radio",
  "Textarea": "Textarea",
  "Rating": "Rating",
  "File Input": "File Input",
  "Otp Input": "Otp Input",
  "Form Layout": "Form Layout",
  "Form Validation": "Form Validation",
  "Charts": "Charts",
  "Apex Chart": "Apex Chart",
  "Chartjs": "Chartjs",
  "Account Settings": "Account Settings",
  "User Profile": "User Profile",
  "FAQ": "FAQ",
  "Dialog Examples": "Dialog Examples",
  "Pricing": "Pricing",
  "List": "List",
  "Edit": "Edit",
  "Nav Levels": "Nav Levels",
  "Level 2.1": "Level 2.1",
  "Level 2.2": "Level 2.2",
  "Level 3.1": "Level 3.1",
  "Level 3.2": "Level 3.2",
  "Raise Support": "Raise Support",
  "Documentation": "Documentation",
  "Dashboards": "Dashboards",
  "Analytics": "Analytics",
  "Apps & Pages": "Apps & Pages",
  "Email": "Email",
  "Chat": "Chat",
  "Invoice": "Invoice",
  "Preview": "Preview",
  "Add": "Add",
  "User": "User",
  "View": "View",
  "Login v1": "Login v1",
  "Login v2": "Login v2",
  "Login": "Login",
  "Register v1": "Register v1",
  "Register v2": "Register v2",
  "Register": "Register",
  "Forget Password v1": "Forget Password v1",
  "Forget Password v2": "Forget Password v2",
  "Forgot Password v1": "Forgot Password v1",
  "Forgot Password v2": "Forgot Password v2",
  "Forgot Password": "Forgot Password",
  "Reset Password v1": "Reset Password v1",
  "Reset Password v2": "Reset Password v2",
  "Reset Password": "Reset Password",
  "Miscellaneous": "Miscellaneous",
  "Coming Soon": "Coming Soon",
  "Not Authorized": "Not Authorized",
  "Under Maintenance": "Under Maintenance",
  "Error": "Error",
  "Statistics": "Statistics",
  "Actions": "Actions",
  "Access Control": "Access Control",
  "User Interface": "User Interface",
  "CRM": "CRM",
  "eCommerce": "eCommerce",
  "Icons": "Icons",
  "Chip": "Chip",
  "Dialog": "Dialog",
  "Expansion Panel": "Expansion Panel",
  "Combobox": "Combobox",
  "Textfield": "Textfield",
  "Range Slider": "Range Slider",
  "Menu": "Menu",
  "Snackbar": "Snackbar",
  "Tabs": "Tabs",
  "Form Elements": "Form Elements",
  "Form Layouts": "Form Layouts",
  "Authentication": "Authentication",
  "Page Not Found - 404": "Page Not Found - 404",
  "Not Authorized - 401": "Not Authorized - 401",
  "Server Error - 500": "Server Error - 500",
  "2": "2",
  "Forms": "Forms",
  "Timeline": "Timeline",
  "Disabled Menu": "Disabled Menu",
  "Help Center": "Help Center",
  "Verify Email": "Verify Email",
  "Verify Email v1": "Verify Email v1",
  "Verify Email v2": "Verify Email v2",
  "Two Steps": "Two Steps",
  "Two Steps v1": "Two Steps v1",
  "Two Steps v2": "Two Steps v2",
  "Custom Input": "Custom Input",
  "Extensions": "Extensions",
  "Tour": "Tour",
  "Register Multi-Steps": "Register Multi-Steps",
  "Wizard Examples": "Wizard Examples",
  "Checkout": "Checkout",
  "Create Deal": "Create Deal",
  "Property Listing": "Property Listing",
  "Roles & Permissions": "Roles & Permissions",
  "Roles": "Roles",
  "Simple Table": "Simple Table",
  "Tables": "Tables",
  "Data Table": "Data Table",
  "Permissions": "Permissions",
  "Apps": "Apps",
  "Misc": "Misc",
  "Wizard Pages": "Wizard Pages",
  "Form Wizard": "Form Wizard",
  "Numbered": "Numbered",
  "3": "3",
  "ecommerce": "ecommerce",
  "Ecommerce": "Ecommerce",
  "Editors": "Editors",
  "Front Pages": "Front Pages",
  "Landing": "Landing",
  "checkout": "checkout",
  "Payment": "Payment",
  "Swiper": "Swiper",
  "Product": "Product",
  "Category": "Category",
  "Order": "Order",
  "Details": "Details",
  "Customer": "Customer",
  "Manage Review": "Manage Review",
  "Referrals": "Referrals",
  "Settings": "Settings",
  "Overview": "Overview",
  "My Course": "My Course",
  "Course Details": "Course Details",
  "Academy": "Academy",
  "Logistics": "Logistics",
  "Dashboard": "Dashboard",
  "Fleet": "Fleet",
  "5": "5",
  "10": "10",
  "20": "20",
  "25": "25",
  "50": "50",
  "100": "100",
  "login": {
    "title": "Welcome back",
    "subtitle": "Sign in to the Operi back office.",
    "tagline": "Orders, pickups and deliveries, all in one place.",
    "errors": {
      "signInFailed": "Sign-in failed. Please try again.",
      "noAccess": "This account has no back-office access.",
      "invalidCredentials": "Wrong email or password.",
      "missingCredentials": "Enter an email and a password."
    },
    "googleCta": "Sign in with Google",
    "orDivider": "or",
    "emailLabel": "Email",
    "passwordLabel": "Password",
    "loginCta": "Log in"
  },
  "orders": {
    "filters": {
      "title": "Planning"
    },
    "plan": {
      "title": "Plan",
      "destinationLabel": "Driving Destination",
      "dateLabel": "Due Date",
      "applyCta": "Plan",
      "resetCta": "Reset",
      "exportCta": "Export CSV",
      "selectDate": "Pick a date to load the plan",
      "loading": "Loading…",
      "empty": "No actions for this date",
      "columns": {
        "order": "Order",
        "action": "Action",
        "name": "Name",
        "address": "Address",
        "suite": "Suite",
        "timeWindows": "Time Windows",
        "phone": "Phone",
        "type": "Type",
        "driver": "Driver"
      },
      "driverLabel": "Driver",
      "allDrivers": "All drivers",
      "unassigned": "Unassigned",
      "overdueSince": "Due {date}"
    },
    "activeViews": {
      "default": "Default view",
      "driving": "Driving view",
      "table": "Table view"
    },
    "active": {
      "drive": "Drive",
      "success": "Success",
      "failed": "Failed",
      "empty": "No active orders",
      "due": "Due",
      "callContact": "Call",
      "messageOnWhatsApp": "Message",
      "customerComment": "Customer comment",
      "moneyNotSecured": "Money not secured",
      "paid": "Paid",
      "amountNotSetYet": "amount not set yet",
      "notPlanned": "Not planned yet",
      "confirmFutureAction": {
        "title": "Confirm action",
        "message": "This action is not due today. Are you sure you want to proceed?",
        "confirm": "Yes, proceed",
        "cancel": "Cancel"
      },
      "confirmAction": {
        "title": "Are you sure?",
        "drive": "Start driving for this order?",
        "success": "Mark this action as successful?",
        "fail": "Mark this action as failed?",
        "confirm": "Yes",
        "cancel": "Cancel"
      },
      "actions": {
        "customerPickup": "Customer Pickup",
        "customerDelivery": "Customer Delivery",
        "storePickup": "Store Pickup",
        "storeDelivery": "Store Delivery"
      },
      "actionHints": {
        "customerPickup": "Collect the bag at the customer's door",
        "customerDelivery": "Hand the clean laundry to the customer",
        "storePickup": "Collect the clean laundry at the store",
        "storeDelivery": "Drop the bag off at the store"
      },
      "openStoreInMaps": "Open the store in Google Maps",
      "loadPaymentFailed": "Could not load the payment details for this order",
      "ready": "Ready",
      "waitingOnLaundry": "Waiting on laundry"
    },
    "details": {
      "noAccess": "This order is not assigned to you any more, so it can no longer be opened here.",
      "noAccessBack": "Back to my driving"
    },
    "dispatch": {
      "title": "Dispatch",
      "driverLabel": "Assigned driver",
      "pickupWindow": "Actual pickup window",
      "deliveryWindow": "Actual delivery window",
      "notPlanned": "Not planned yet",
      "assignedTo": "Assigned to {name}",
      "appliesTo": "For"
    },
    "driveBoard": {
      "today": "Today",
      "tomorrow": "Tomorrow",
      "previousDay": "Previous day",
      "nextDay": "Next day",
      "backToToday": "Back to today",
      "unplanned": "Unplanned",
      "laundry": "Laundry hand-overs",
      "readyEarly": "Ready early",
      "empty": "Nothing to drive on this day"
    },
    "reorder": {
      "up": "Move up",
      "down": "Move down"
    },
    "deliveryType": {
      "quick": "Quick",
      "regular": "Regular"
    },
    "paymentMethod": {
      "CASH_ON_DELIVERY": "Cash on delivery",
      "CARD_ON_DELIVERY": "Card on delivery",
      "ONLINE_CARD": "Online card"
    },
    "nextAction": {
      "pickup": "PICKUP",
      "delivery": "DELIVERY"
    }
  },
  "$vuetify": {
    "badge": "Badge",
    "noDataText": "No data available",
    "close": "Close",
    "open": "open",
    "carousel": {
      "ariaLabel": {
        "delimiter": "delimiter"
      }
    },
    "dataFooter": {
      "itemsPerPageText": "Items per page:",
      "itemsPerPageAll": "All",
      "pageText": "{0}-{1} of {2}",
      "firstPage": "First Page",
      "prevPage": "Previous Page",
      "nextPage": "Next Page",
      "lastPage": "Last Page"
    },
    "pagination": {
      "ariaLabel": {
        "root": "root",
        "previous": "previous",
        "next": "next",
        "currentPage": "currentPage",
        "page": "page"
      }
    },
    "input": {
      "clear": "clear",
      "appendAction": "appendAction",
      "prependAction": "prependAction",
      "counterSize": "counterSize",
      "otp": "otp"
    },
    "fileInput": {
      "counterSize": "counterSize"
    },
    "rating": {
      "ariaLabel": {
        "item": "item"
      }
    }
  },
  "driver": {
    "delivery": {
      "title": "Complete delivery {order}",
      "amountToCollect": "To collect:",
      "tenderQuestion": "What did the customer pay with?",
      "alreadyPaid": "Already paid — nothing to collect at the door.",
      "tender": {
        "cash": "Cash",
        "card": "Card on terminal",
        "ips": "IPS QR code",
        "notCollected": "Nothing collected"
      },
      "overrideLabel": "Deliver without collecting the money",
      "overrideReasonLabel": "Why?",
      "confirm": "Confirm delivery",
      "cancel": "Cancel",
      "failed": "Could not complete the delivery.",
      "loadFailed": "Could not load the order's payment details."
    }
  },
  "availability": {
    "pickup": "Pickup",
    "delivery": "Delivery",
    "tabs": {
      "calendar": "Calendar",
      "nonWorking": "Non-working days",
      "weekly": "Weekly closures",
      "reasons": "Reasons",
      "windows": "Time windows",
      "settings": "Settings"
    },
    "state": {
      "open": "Bookable",
      "beyond": "Beyond the offered days",
      "closed": "Closed",
      "windowsClosed": "All windows closed",
      "nonWorking": "Non-working",
      "past": "Past"
    },
    "scope": {
      "OPERI": "Operi",
      "LAUNDRY": "Laundry",
      "BOTH": "Both"
    },
    "reason": {
      "PAST": "In the past",
      "WEEKLY_NON_WORKING": "Weekly closure",
      "NON_WORKING_DAY": "Non-working day",
      "DAY_CLOSED": "Closed by admin",
      "ALL_WINDOWS_CLOSED": "Every window is closed",
      "BEYOND_HORIZON": "Beyond the days currently offered",
      "TOO_EARLY": "Too early — nothing collected now is back by then"
    },
    "window": {
      "OPEN": "Open",
      "CLOSED": "Closed",
      "PASSED": "Passed",
      "NON_WORKING": "Non-working"
    },
    "drawer": {
      "bookable": "Bookable",
      "wholeDay": "Whole day",
      "dayClosed": "This date is closed for bookings.",
      "reopenDay": "Reopen the day",
      "reasonLabel": "Reason",
      "noteLabel": "Note (optional)",
      "closeDay": "Close the whole day",
      "nothingToDecide": "Nothing to close here — the date is already unavailable.",
      "windows": "Time windows",
      "reopen": "Reopen",
      "close": "Close",
      "notClosable": "Already unavailable",
      "planner": "Driving actions",
      "opening": "Beyond the offered days",
      "openDay": "Open this day",
      "openDayHint": "These dates are fine, they are simply further out than the days customers are being offered. Opening one offers it as an extra date on that side.",
      "dayOpened": "Opened by hand, so customers are offered it on top of the usual days.",
      "removeOpening": "Stop offering it",
      "notOnThisSide": "not offered",
      "notBeyondBand": "Not held back by the band",
      "openWindow": "Open for this day",
      "closeForThisDay": "Close for this day",
      "closedByRule": "Closed by the window rule",
      "openedForThisDay": "Opened for this day",
      "nonWorkingBecause": "{who}: {reason}",
      "nonWorking": {
        "OPERI": "Operi is not driving this date",
        "LAUNDRY": "The laundry is closed this date — collections and returns still run",
        "BOTH": "Operi is not driving and the laundry is closed this date"
      },
      "openingRedundant": "Inside the days on offer now — removing this changes nothing"
    },
    "reasons": {
      "nameLabel": "New reason",
      "add": "Add",
      "name": "Reason",
      "status": "",
      "restore": "Restore",
      "archive": "Archive",
      "empty": "No reasons yet."
    },
    "nonWorking": {
      "dateLabel": "Date",
      "scopeLabel": "Who is off",
      "reasonLabel": "Reason",
      "add": "Add",
      "date": "Date",
      "scope": "Who is off",
      "reason": "Reason",
      "remove": "Remove",
      "empty": "No non-working days in the next year."
    },
    "weekly": {
      "explainer": "Standing closures, every week. Operi normally has none — it drives seven days — while the laundry is closed on Sundays. Changing this changes which dates customers are offered.",
      "OPERI": "Operi does not drive",
      "LAUNDRY": "Laundry does not process",
      "save": "Save weekly closures",
      "saved": "Saved"
    },
    "weekday": {
      "MONDAY": "Mon",
      "TUESDAY": "Tue",
      "WEDNESDAY": "Wed",
      "THURSDAY": "Thu",
      "FRIDAY": "Fri",
      "SATURDAY": "Sat",
      "SUNDAY": "Sun"
    },
    "planner": {
      "loading": "Loading the plan…",
      "empty": "Nothing planned for this date.",
      "customerPrefers": "Customer can manage:",
      "notPlanned": "Not planned yet",
      "unplannedHeading": "Not planned into a window yet",
      "noWindowHeading": "No window to plan",
      "noWindowHint": "Hand-overs with the laundry. They belong to no time window.",
      "windowEmpty": "Nothing in this window",
      "windowFilteredOut": "{count} here, hidden by the driver filter",
      "outsidePreference": "Outside the windows the customer chose",
      "storeLegs": "Store hand-overs (no customer window)",
      "operiClosed": "Nobody drives on this date. The work has moved to the next working day.",
      "laundryClosed": "A laundry closure adds a processing day. Drives to and from it are unaffected.",
      "windowLabel": "Actual window",
      "hiddenByFilter": "{count} hidden by the driver filter",
      "emptyForDriver": "Nothing on this date matches the driver filter.",
      "noWindowToPlan": "No window to plan — hand-over with the laundry",
      "sideLabel": "Side",
      "bothSides": "Pickup and delivery",
      "allPlanned": "Everything has a window.",
      "toggleWindow": "Collapse or expand this window",
      "needsDriver": "Needs a driver",
      "expandCard": "Show details",
      "noteLabel": "Note for the driver",
      "notePlaceholder": "Shown on the driving card",
      "noteSaved": "Saved"
    },
    "dayPanel": {
      "editAvailability": "Edit availability",
      "openWindows": "{open} of {total} windows open"
    },
    "calendar": {
      "windowsShort": "{open}/{total} windows",
      "windowsTitle": "{open} of {total} booking windows open",
      "actionsTitle": "{side}: {orders} orders ({customer} customer stops, {store} store hand-overs)",
      "legendLoad": "Orders to organise",
      "legendNonWorking": "Who is not working",
      "openedShort": "Opened",
      "legendOpened": "Opened by hand",
      "openedTitle": "Opened by hand, on top of the days on offer",
      "legendSides": "Pickup / delivery bookable",
      "legendUnmanaged": "Orders with no window yet",
      "sideTitle": "{side}: {orders} orders, {unmanaged} with no window",
      "legendWindowClosed": "Orders per window: open / closed",
      "openShort": "open",
      "nothingAhead": "Nothing left in this month.",
      "closed": {
        "operi": "Operi not driving",
        "laundry": "Laundry closed"
      },
      "legendWindowAbsent": "not offered for this side"
    },
    "windows": {
      "explainer": "Time windows come in two parts: the hours the platform can offer, and which of them are currently on sale.",
      "everyDay": "Closed by default, every day",
      "byWeekday": "Exceptions by weekday",
      "byWeekdayHint": "For hours that differ on one day of the week, such as a later start on Saturdays. A weekday rule is separate from the every-day switch above.",
      "closedByDefault": "closed by default",
      "openByDefault": "open",
      "noWindows": "The active rule defines no time windows.",
      "noRule": "Could not load the configured time windows.",
      "weekdayLabel": "Weekday",
      "windowLabel": "Window",
      "sidesLabel": "Sides",
      "addWeekday": "Add weekday rule",
      "remove": "Remove",
      "addWindow": "Add window",
      "removeWindow": "Remove",
      "removeWindowHint": "Takes the window off the menu on this side. Orders already planned into it keep it.",
      "startLabel": "From",
      "endLabel": "To",
      "lastWindow": "Last window on this side — close it on the tab below instead.",
      "save": "Save time windows",
      "discard": "Cancel",
      "unsaved": "Unsaved changes — nothing is live until you save.",
      "saved": "Saved.",
      "menuHeading": "The hours we can offer",
      "menuHint": "Which time windows exist at all, for collection and for return. Nothing here is live until you save.",
      "availabilityHeading": "What is on sale",
      "availabilityHint": "Which of those hours accept bookings, on every date. Changes here take effect immediately. Closing one date, or one window on one date, is done on the Calendar tab instead.",
      "offered": "offered",
      "edit": "Edit time windows",
      "menuRead": "The time windows the platform can offer, for collection and for return. Changing them is rare — it changes what customers can book.",
      "willBeRemoved": "Off on both sides — this window goes when you save."
    },
    "settings": {
      "booking": "Booking",
      "rescheduling": "Rescheduling",
      "checkoutCutoff": "Book at least",
      "checkoutCutoffHint": "How long before a window an order can still be placed in it. A window stops being offered once it is this close.",
      "rescheduleLead": "Reschedule at least",
      "rescheduleLeadHint": "How long before their own window a customer can still move an order. Counted in working time only — the hours between the office closing and opening again do not count, so a 09:00 window is locked the previous evening rather than in the middle of the night.",
      "officeStart": "Office opens",
      "officeEnd": "Office closes",
      "officeHoursHint": "The hours the reschedule deadline is counted in. Not the booking windows — this is when somebody is here to act on a change.",
      "quickDelivery": "Quick delivery",
      "quickDeliveryMinHours": "Deliver at least",
      "quickDeliveryMinHoursSuffix": "hours after pickup",
      "quickDeliveryMinHoursHint": "Counted from the end of the latest pickup window the customer chose to the start of a quick delivery window. With 18, a pickup ending at 21:00 can come back from 15:00 the next day, not that morning. 0 turns the limit off. Regular delivery is not affected.",
      "minutes": "minutes",
      "workingMinutes": "working minutes",
      "hours": "{hours}h of working time",
      "save": "Save",
      "saved": "Saved"
    }
  },
  "drivers": {
    "add": "Add driver"
  },
  "partner": {
    "settings": {
      "title": "Partner settings",
      "edit": "Edit",
      "drawerTitle": "Edit partner settings",
      "on": "On",
      "off": "Off",
      "ignoreDeliveryAreas": {
        "label": "Ignore delivery areas",
        "description": "Can add addresses and order anywhere, even outside delivery areas."
      },
      "manualCashFiscalReceipt": {
        "label": "Manual cash receipts",
        "description": "Cash payments get no automatic fiscal receipt. Card payments are always fiscalized."
      },
      "discountPercent": {
        "label": "Partner level",
        "description": "Sets the discount prefilled on every new order. Applied to the full order total."
      },
      "appliesFromNow": "Changes apply to orders placed from now on. Orders already placed keep their settings.",
      "lastChanged": "Last changed {date}",
      "save": "Save",
      "discard": "Discard",
      "saved": "Partner settings saved.",
      "saveFailed": "Could not save the partner settings.",
      "user": {
        "label": "Customer",
        "placeholder": "Search by name or email",
        "required": "Pick a customer first."
      }
    },
    "levels": {
      "FRESH": "FRESH",
      "ESSENTIAL": "ESSENTIAL",
      "PREMIUM": "PREMIUM",
      "PLATINUM": "PLATINUM",
      "STAKEHOLDER": "STAKEHOLDER"
    },
    "level": {
      "none": "No discount",
      "custom": "CUSTOM",
      "customPercent": "Custom {percent}%",
      "customHint": "{percent}% matches no level. It stays until you pick one.",
      "discount": "{percent}% discount",
      "legend": "Partner levels"
    },
    "page": {
      "title": "Partners",
      "subtitle": "Partner level sets the discount on new orders. Benefits apply on top of any level.",
      "add": "Add partner",
      "other": "Other",
      "otherHint": "A discount matching no level, or benefits only",
      "loadFailed": "Could not load the partners.",
      "customer": "Customer",
      "benefits": "Benefits",
      "discount": "Discount",
      "lastChanged": "Last changed",
      "edit": "Edit"
    },
    "list": {
      "column": "Partner",
      "chip": "PARTNER"
    },
    "order": {
      "chip": "Partner",
      "discount": "{percent}% partner discount",
      "manualCashReceipt": "Manual cash receipt",
      "outsideDeliveryArea": "Outside delivery area"
    },
    "discount": {
      "chip": "Partner {percent}%",
      "differs": "Differs from partner discount ({percent}%)",
      "restore": "Restore"
    },
    "fiscal": {
      "explanation": "Cash receipts for this customer are issued only on request.",
      "awaitingPayment": "A receipt can be issued once the payment is recorded.",
      "issueButton": "Issue fiscal receipt",
      "issueQuestion": "Issue fiscal receipt for {order}?",
      "issueDescription": "This sends a receipt of {amount}, paid with {tender}, to eFiskalizacija. A fiscal receipt is an official document. It cannot be withdrawn, only reversed with a refund.",
      "issueConfirmTitle": "Issue requested",
      "issueConfirmMsg": "The fiscal receipt has been requested.",
      "issueCancelTitle": "Not issued",
      "issued": "Fiscal receipt issued.",
      "issueFailed": "Could not issue the fiscal receipt.",
      "noReceiptOnCash": "No fiscal receipt will be issued. You can issue one later from the payment panel.",
      "markPaidDelivered": "Record that the customer paid this order with {tender}? No fiscal receipt will be issued. You can issue one later from the payment panel. This cannot be undone, use \"Mark refunded\" to correct it.",
      "markPaidNotDelivered": "This order has NOT been delivered yet. Recording that the customer paid with {tender} cannot be undone. No fiscal receipt will be issued. You can issue one later from the payment panel. Mark it paid anyway?",
      "recordedWithoutReceipt": "Payment recorded. No fiscal receipt was issued.",
      "refundWithoutReceipt": "This only updates the status in Operi - it does not move any money. Refund the customer on the Monri dashboard first. No fiscal receipt was issued for this payment, so no refund receipt is issued either."
    }
  },
  "freeOrder": {
    "chip": "Free order",
    "panelText": "No payment needed. Nothing is reserved, collected or fiscalized.",
    "nothingToCollect": "Free order, nothing to collect.",
    "noPaymentToCollect": "No payment to collect",
    "approvalNote": "This order will be free. Nothing will be reserved or collected.",
    "approvalReleaseNote": "The card reservation will be released."
  },
  "orderItems": {
    "pricingFailed": "Could not update the prices: {message}",
    "saveFailed": "Could not save the order items: {message}",
    "unknownError": "unexpected error",
    "conflict": "The outsource company sent a newer classification for this order. Reload to see it before changing prices.",
    "reload": "Reload",
    "recalculated": "Recalculated from the pricelist. Total went from {before} RSD to {after} RSD.",
    "recalculatedUnchanged": "Recalculated from the pricelist. The total stays {after} RSD.",
    "mappingApplied": "Mapped quantities applied. Review the prices and save to keep them.",
    "pendingDraftWarning": "A newer outsource classification is waiting in the Draft tab. Updating from here marks it approved without adding its items. Use the Draft tab if those items should be charged.",
    "mapping": {
      "unmapped": "{count} outsource item(s) have no mapping, so they are not on the order: {names}.",
      "openMapping": "Open mapping",
      "unpriced": "Mapped to a service with no price in this order's pricelist: {names}. Pricing fails until the service is priced or the mapping changes.",
      "differs": "The special laundry items differ from what the outsource items give under the current mapping. This happens when the mapping changed after the items were set, or when items were edited by hand.",
      "line": "{name}: {onOrder} on the order, {fromMapping} from the mapping",
      "apply": "Use mapped quantities",
      "recheck": "Re-check mapping",
      "inSync": "Special laundry items match the outsource mapping."
    }
  },
  "acquisition": {
    "organic": "Organic / none",
    "fields": {
      "channel": "Channel",
      "campaign": "Campaign",
      "medium": "Medium",
      "referrer": "Referrer",
      "tags": "Tags",
      "recordedAt": "Recorded"
    },
    "card": {
      "title": "Marketing source",
      "signupSource": "Signed up from",
      "noSignupSource": "No signup source recorded. The app did not report one, or the account is older than the tracking.",
      "linkOpens": "Recent link opens ({count})",
      "noLinkOpens": "No marketing link opens recorded.",
      "via": "via {referrer}",
      "showAll": "Show {count} more",
      "showFewer": "Show fewer",
      "loadFailed": "Could not load the marketing source."
    },
    "page": {
      "title": "Acquisition",
      "subtitle": "Signups, first orders and link opens per channel and campaign. Signups and first orders count customers who signed up in the range, link opens count opens in the range.",
      "from": "From",
      "to": "To",
      "signups": "Signups",
      "firstOrders": "First orders",
      "conversion": "Conversion",
      "linkOpens": "Link opens",
      "allCampaigns": "All campaigns",
      "noCampaign": "No campaign",
      "total": "Total",
      "empty": "No signups or link opens in this range.",
      "invalidRange": "The start date has to be on or before the end date.",
      "loadFailed": "Could not load the acquisition summary."
    }
  },
  "outsourcePayments": {
    "title": "Outsource payments",
    "subtitle": "We owe the outsource company for an order once we pick it up from them (store pickup done), and pay on the 15th and on the last day of the month. Last pay date {last}, next {next}.",
    "loadFailed": "Could not load outsource payments.",
    "saveFailed": "Could not save. Try again.",
    "invalidRange": "The start date must be on or before the end date.",
    "marginNote": "Margin is what the customer pays minus what we pay the outsource company, before drivers, packaging and every other expense. Margin % is that share of what the customer pays.",
    "tiles": {
      "due": "Due now",
      "dueHint": "picked up by {date}",
      "notDueYet": "Not due yet",
      "notDueYetHint": "due on {date}",
      "upcoming": "At outsource company",
      "upcomingHint": "owed once picked up",
      "paid": "Paid",
      "paidHint": "picked up or paid ahead {from} to {to}",
      "orders": "{count} orders",
      "customersPay": "Customers pay",
      "margin": "Margin"
    },
    "tabs": {
      "unpaid": "Unpaid ({count})",
      "upcoming": "At outsource company ({count})",
      "paid": "Paid"
    },
    "markAllDue": "Mark all due as paid ({count})",
    "markSelectedPaid": "Mark selected as paid ({count})",
    "markSelectedUnpaid": "Mark selected as unpaid ({count})",
    "selectedTotal": "Selected: {amount}",
    "upcomingNote": "Active orders with approved outsource items not picked up from the outsource company yet. They can be paid ahead. Once the store pickup is done they move to Unpaid, or to Paid when already paid.",
    "markedPaid": "{count} orders marked as paid",
    "markedUnpaid": "{count} orders marked as unpaid",
    "confirm": {
      "paidTitle": "Mark as paid",
      "unpaidTitle": "Mark as unpaid",
      "paidText": "Mark {count} orders, {amount} in total, as paid to the outsource company?",
      "unpaidText": "Mark {count} orders, {amount} in total, as not paid to the outsource company?",
      "cancel": "Cancel",
      "ok": "Confirm"
    },
    "table": {
      "order": "Order",
      "customer": "Customer",
      "status": "Status",
      "company": "Outsource company",
      "outsource": "Outsource cost",
      "customerPays": "Customer pays",
      "margin": "Margin",
      "paidAt": "Paid at",
      "loading": "Loading...",
      "empty": "No orders here.",
      "due": "Due",
      "notDueYet": "Not due yet",
      "notPriced": "Not priced",
      "total": "Total, {count} orders",
      "pricelist": "Pricelist",
      "marginPercent": "Margin %",
      "storePickup": "Store pickup",
      "atCompany": "At outsource company",
    "paidAhead": "Paid {date}"
    },
    "order": {
      "paid": "Outsource paid {date}",
      "due": "Outsource payment due",
      "unpaid": "Outsource not paid yet",
      "markPaid": "Mark outsource paid",
      "markUnpaid": "Mark outsource unpaid"
    },
    "noPricelist": "No pricelist",
    "pricelistFilter": "Pricelist",
    "allPricelists": "All pricelists",
    "breakdown": {
      "title": "Margin by pricelist",
      "subtitle": "Orders on the tab below, grouped by the Operi pricelists they were charged by. Click a pricelist to filter.",
      "orders": "Orders"
    },
    "storePickupFrom": "Store pickup from",
    "storePickupTo": "Store pickup to"
  },
  "testAccount": {
    "hide": "Hide store test accounts",
    "hiddenCount": "{count} hidden",
    "hint": "Accounts that Google Play's pre-launch robot and Apple's reviewers create while testing a release.",
    "badge": "Test",
    "chip": "Store test account",
    "markAsTest": "Mark as test account",
    "markAsCustomer": "Mark as real customer",
    "markedAsTest": "Marked as a store test account. It is hidden from the customer list and from Slack.",
    "markedAsCustomer": "Marked as a real customer. Automatic detection will not hide it again.",
    "markFailed": "Could not change the test account mark. Try again.",
    "reasons": {
      "TEST_LAB_NETWORK": "Google Test Lab network",
      "TEST_LAB_DEVICE": "Google Test Lab device",
      "PLAY_ROBOT_EMAIL": "Play pre-launch robot email",
      "APPLE_NETWORK": "Apple network, likely App Review",
      "MARKED_BY_ADMIN": "Marked by an admin"
    }
  },
  "cashDeposits": {
    "title": "Cash deposits",
    "subtitle": "Cash collected for fiscalized orders and the deposits put in the bank ATM. Cash is due at the bank within {days} day after the order is done, and the ATM takes only hundreds. | Cash collected for fiscalized orders and the deposits put in the bank ATM. Cash is due at the bank within {days} days after the order is done, and the ATM takes only hundreds.",
    "subtitleLoading": "Cash collected for fiscalized orders and the deposits put in the bank ATM. The ATM takes only hundreds.",
    "recordDeposit": "Record deposit",
    "loadFailed": "Could not load cash deposits.",
    "saveFailed": "Could not save. Try again.",
    "invalidRange": "The start date must be on or before the end date.",
    "loading": "Loading...",
    "cancel": "Cancel",
    "overdue": "Overdue",
    "underHundred": "under 100 RSD, goes with the next deposit",
    "relative": {
      "today": "today",
      "inDays": "in {count} day | in {count} days",
      "daysLate": "{count} day late | {count} days late"
    },
    "tiles": {
      "left": "Left to deposit",
      "canPutIn": "you can put in {amount} now",
      "depositedMore": "deposited {amount} more than collected",
      "nothingWaiting": "nothing waiting",
      "overdueHint": "put it in as soon as possible, the oldest was due by {date}",
      "nextDeadline": "Next deadline",
      "due": "{amount} due",
      "deposited": "Deposited",
      "depositedHint": "{count} deposit from {from} to {to} | {count} deposits from {from} to {to}"
    },
    "deadlines": {
      "title": "Deadlines",
      "subtitle": "The last day each amount can go to the bank. An amount is all cash due by that day minus every deposit, rounded down to 100.",
      "orders": "{count} order | {count} orders",
      "empty": "No cash is waiting for a deposit.",
      "onlyUnderHundred": "Nothing is due. The {amount} left is under 100 RSD and goes with the next deposit."
    },
    "tabs": {
      "waiting": "Waiting ({count})",
      "deposits": "Deposits",
      "orders": "All cash orders"
    },
    "waitingNote": "Orders whose cash is not fully deposited yet, oldest first. Deposits pay off the oldest cash first.",
    "depositedFrom": "Deposited from",
    "depositedTo": "Deposited to",
    "doneFrom": "Done from",
    "doneTo": "Done to",
    "orders": {
      "order": "Order",
      "customer": "Customer",
      "doneAt": "Done at",
      "dueBy": "Due by",
      "amount": "Amount",
      "left": "Left",
      "paidOff": "Paid off",
      "empty": "No orders here.",
      "total": "Total, {count} order | Total, {count} orders"
    },
    "deposits": {
      "day": "Day",
      "amount": "Amount",
      "recordedBy": "Recorded by",
      "note": "Note",
      "status": "Status",
      "revert": "Revert",
      "revertedBy": "Reverted by {name} on {date}",
      "revertedOn": "Reverted on {date}",
      "empty": "No deposits here.",
      "total": "Total, {count} deposit | Total, {count} deposits"
    },
    "dialog": {
      "title": "Record deposit",
      "intro": "{amount} is left to deposit. The ATM takes only hundreds, the rest under 100 waits for the next deposit.",
      "amount": "Amount",
      "amountHint": "up to {amount}, in hundreds",
      "day": "Day put in the ATM",
      "note": "Note (optional)",
      "notePlaceholder": "Which ATM, the slip number",
      "save": "Record",
      "required": "Required",
      "atLeast": "At least 100 RSD",
      "hundreds": "Only hundreds, the ATM takes multiples of 100",
      "atMost": "At most {amount}, what can go in now",
      "notFuture": "Not a day in the future",
      "noteTooLong": "At most {max} characters"
    },
    "revert": {
      "title": "Revert deposit",
      "text": "Revert the {date} deposit of {amount}? It stays in the history marked reverted, and its cash counts as left to deposit again.",
      "ok": "Revert"
    },
    "recorded": "Deposit of {amount} on {date} recorded",
    "reverted": "Deposit of {amount} reverted"
  },
  "orderFamily": {
    "title": "Order family",
    "orderCount": "{count} orders",
    "parent": "Parent",
    "extraTime": "Extra time",
    "freeDeliveryReached": "Free delivery reached",
    "toFreeDelivery": "{amount} to free delivery",
    "familyLaundry": "Family laundry",
    "familyLaundryOf": "{total} of {threshold} for free delivery",
    "familyLaundryNoThreshold": "{total}, no free delivery threshold",
    "familyTotal": "Family total",
    "notPricedCount": "{count} not priced yet",
    "splitAt": "Split",
    "loadFailed": "Could not load the order family.",
    "member": {
      "delivery": "Delivery {when}",
      "laundry": "Laundry {laundry}",
      "laundryAndFees": "Laundry {laundry} + fees {fees}",
      "notPriced": "Not priced yet"
    },
    "status": {
      "completed": "Completed",
      "canceled": "Canceled",
      "onHold": "On hold"
    },
    "steps": {
      "created": "Created",
      "pickup": "Pickup",
      "storeDelivery": "Store delivery",
      "classifiedDraft": "Classified, draft",
      "awaitingClassification": "Waiting for classification",
      "processing": "Processing",
      "storePickup": "Store pickup",
      "delivery": "Delivery"
    },
    "marker": {
      "parent": "Parent of {count}",
      "child": "Part of #{code}",
      "parentTooltip": "Split into {total} orders",
      "childTooltip": "Split off #{code}, {total} orders in the family"
    },
    "events": {
      "copiedFrom": "from #{code}"
    },
    "splitDialog": {
      "button": "Split order",
      "title": "Split order #{code}",
      "intro": "Each child order keeps this order's history and state, gets its own code, and is classified and delivered on its own.",
      "child": "Child order {index}",
      "remove": "Remove",
      "readyDate": "Ready date",
      "readyDateHint": "Agreed with the customer",
      "dateRequired": "Pick a date",
      "dateInPast": "Pick today or a later date",
      "windows": "Delivery windows",
      "windowsRequired": "Pick at least one window",
      "note": "Note for the team, not shown to the customer",
      "addChild": "Add child order",
      "parentKeeps": "The parent keeps its delivery on {delivery}. Child orders get Naknadna dostava instead of Pickup & Delivery.",
      "cancel": "Cancel",
      "submit": "Split into {count} orders",
      "failed": "Could not split the order.",
      "failedWithReason": "Could not split the order. {message}"
    },
    "splitDone": {
      "title": "Order split into {count} orders",
      "parentLine": "Parent, delivery {date}",
      "childLine": "Delivery {date}",
      "new": "New",
      "codesTitle": "Codes for the laundry",
      "codesHint": "The laundry classifies each item under the code it belongs to.",
      "copy": "Copy codes",
      "copied": "Copied",
      "copyFailed": "Could not copy. Select the codes and copy them by hand.",
      "open": "Open #{code}",
      "done": "Done"
    }
  },
  "familyPricing": {
    "title": "Family pricing",
    "childOf": "Child order of #{code}, {count} orders in the family",
    "parentOf": "Parent order, {count} orders in the family",
    "familyLaundry": "Family laundry",
    "laundryOf": "{total} of {threshold}",
    "reached": "Free delivery reached",
    "notReached": "Free delivery not reached",
    "noThreshold": "No free delivery threshold",
    "deliveryFee": "Delivery fee",
    "extraDelivery": "Naknadna dostava, {amount}",
    "extraDeliveryNone": "No Naknadna dostava",
    "insteadOfDelivery": "Instead of Pickup & Delivery",
    "pickupDelivery": "Pickup & Delivery, {amount}",
    "pickupDeliveryNone": "No Pickup & Delivery",
    "freeFromFamilyTotal": "Free from {threshold} on the family total",
    "minOrderFee": "Minimum order fee",
    "notCharged": "Not charged",
    "parentOnly": "Parent only, on the family total",
    "notNeeded": "Not needed",
    "checkedOnFamilyTotal": "Checked on the family total",
    "quickFee": "Quick delivery fee",
    "neverOnChild": "Never on a child order",
    "allClassified": "All {count} orders are classified, so the family total is final.",
    "pendingClassification": "Not classified yet: {codes}. Free delivery and the minimum order fee can still change.",
    "extraDeliveryFeeLabel": "Naknadna dostava (RSD)"
  },
  "extraDeliveryFee": {
    "name": "Naknadna dostava",
    "notCreated": "Not created yet",
    "hint": "Added to every child order of a split, in place of Pickup & Delivery. Free when the family reaches free delivery. The admin can change or remove it on the approval page.",
    "pricesHint": "Each pricelist sets its own price under Pricelists, Delivery and fees.",
    "editPrices": "Edit prices",
    "edit": "Edit",
    "create": "Create",
    "createTitle": "Create Naknadna dostava",
    "editTitle": "Edit Naknadna dostava",
    "nameKey": "Name key",
    "descriptionKey": "Description key",
    "miniImageKey": "Mini image key",
    "detailImageKey": "Detail image key",
    "showAllKeys": "Show all translation keys",
    "cancel": "Cancel",
    "save": "Save",
    "saved": "Naknadna dostava saved",
    "saveFailed": "Could not save Naknadna dostava.",
    "saveFailedWithReason": "Could not save Naknadna dostava. {message}"
  }
}
